module.exports = __webpack_public_path__ + "static/img/temp.31d0652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/temp.png
// module id = /xlw
// module chunks = 1